<template>
  <FocusLayout :title="$t('Welcome back')" :subtitle="$t('Please sign in to continue')">
    <LoginForm @authenticated="$router.push({ name: 'home' })" v-bind="$attrs"></LoginForm>
  </FocusLayout>
</template>

<script>
import FocusLayout from "@/landing/layout/FocusLayout";
import LoginForm from "@c/Auth/LoginForm";

export default {
  components: { FocusLayout, LoginForm },
  created() {
    if (this.$store.state.auth) this.$router.push({ name: "home" });
  },
};
</script>
